import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./PDFModal.css";

const PDFModal = (props) => {
  let onHide = props.onHide;
  if (typeof props.attributes != "undefined") {
    onHide = props.attributes.onHide;
  }

  const SavePDF = () => {
    const divContents = document.getElementById("PDFDiv").innerHTML;
    const printWindow = window.open("", "", "height=400,width=800");
    printWindow.document.write("<html><head><title>Print / PDF</title></head><body>");
    printWindow.document.write(divContents);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div className="modal">
      <Modal
        {...props}
        animation={false}
        dialogClassName="pdm-dialog"
        aria-labelledby="pdm-title"
        centered={false}
        scrollable={false}
        onHide={onHide}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="pdm-shell">

            {/* ── Header ── */}
            <div className="pdm-header">
              <div className="pdm-header-icon">
                <FontAwesomeIcon icon={solid("file-pdf")} />
              </div>
              <h2 className="pdm-title" id="pdm-title">Print / PDF</h2>
              <div className="pdm-header-actions">
                <button className="pdm-print" onClick={SavePDF}>
                  <FontAwesomeIcon icon={solid("print")} />
                  Print
                </button>
                <button className="pdm-close" onClick={onHide}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>
            </div>

            {/* ── Body ── */}
            <div className="pdm-body">
              <div
                className="pdm-content"
                dangerouslySetInnerHTML={{ __html: props.htmlString }}
                id="PDFDiv"
              />
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PDFModal;
